import React, { useState } from 'react';
import { Tabs, Tab, Grid } from '@mui/material';
import RichTextEditorField from './RichTextEditorField'; // Mevcut RichTextEditor bileşeniniz
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const MultilingualRichTextEditor = ({ touched, errors, languages, description, onChange, a11yProps }) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={1}>
                <Tabs
                    orientation="vertical"
                    value={activeTab}
                    onChange={handleTabChange}
                    aria-label="Language Tabs"
                    sx={{ borderRight: 1, borderColor: 'divider' }}
                >
                    {
                        languages.map((lang, index) => (
                            <Tab label={
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    {lang.label}
                                    {(touched.description?.[lang.code] && errors.description?.[lang.code]) ? <ReportProblemIcon color="error" sx={{ fontSize: '1.3em', marginLeft: "5px" }} /> : null}
                                </div>
                            } {...a11yProps(0)} />
                        ))
                    }

                </Tabs>
            </Grid>
            <Grid item xs={12} sm={11}>
                {languages.map((lang, index) => (
                    <div
                        key={lang.code}
                        role="tabpanel"
                        hidden={activeTab !== index}
                        id={`tabpanel-${index}`}
                        aria-labelledby={`tab-${index}`}
                    >
                        {activeTab === index && (
                            <RichTextEditorField
                                key={lang.code}
                                value={description[lang.code]}
                                onChange={(newValue) =>
                                    onChange(newValue, lang.code)
                                }
                                height="500px"
                                placeholder={`Enter content for ${lang.label}`}
                            />
                        )}
                    </div>
                ))}
            </Grid>
        </Grid>
    );
};

export default MultilingualRichTextEditor;
